import axios, { AxiosError, AxiosRequestConfig } from "axios"
import {
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials,
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
} from "interceptors"
import { ATS_PATH, FIELDS, REPORT_PATH, UPLOAD_PATH } from "lib"

const instance = axios.create({
  baseURL: process.env.REACT_APP_DOCUMENTS_API_SERVICE_DOMAIN,
})
instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)
const formDataConfig: AxiosRequestConfig = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
}

export const uploadATSFileService = async (file: any) => {
  const formData = new FormData()
  formData.append(FIELDS.file.key, file)
  try {
    const result = await instance.post(
      REPORT_PATH + ATS_PATH + UPLOAD_PATH,
      formData,
      formDataConfig
    )
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}
